export async function apiFetch(url, options = {}, token = null) {
  const headers = {
    ...(options.headers || {})
  };

  let body = options.body;
  if (body !== undefined && !(body instanceof FormData) && !(body instanceof Blob) && typeof body !== 'string') {
    headers['Content-Type'] = headers['Content-Type'] || 'application/json';
    body = JSON.stringify(body);
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
    body
  });

  const contentType = response.headers.get('content-type') || '';
  const data = contentType.includes('application/json')
    ? await response.json().catch(() => null)
    : await response.text().catch(() => '');

  if (!response.ok) {
    const error = new Error(data?.error || data || `HTTP ${response.status}`);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}

export async function apiBlob(url, token = null) {
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, { headers });
  if (!response.ok) {
    let data = null;
    try {
      data = await response.json();
    } catch (_) {
      data = await response.text().catch(() => '');
    }
    const error = new Error(data?.error || data || `HTTP ${response.status}`);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return response.blob();
}
